/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetPendingTransactionsQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.StakingHistoryFilter>;
	order?: Types.InputMaybe<
		Array<Types.InputMaybe<Types.StakingHistoryOrder>> | Types.InputMaybe<Types.StakingHistoryOrder>
	>;
}>;

export type GetPendingTransactionsQuery = {
	__typename?: "Query";
	history: Array<{
		__typename?: "StakingAction";
		type: Types.StakingActionType;
		status?: Types.StakingStatusType | null;
		asset: { __typename?: "StakeableAsset"; assetId: string };
		assetAmount: { __typename?: "CurrencyAmount"; value: string };
		fiatAmount?: { __typename?: "CurrencyAmount"; value: string } | null;
		createdAt: { __typename?: "DateTime"; iso8601: string };
		releaseTimestamp?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
		firstRewardPayoutAt?: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number } | null;
	}>;
};

export const GetPendingTransactionsDocument = gql`
	query GetPendingTransactions($filter: StakingHistoryFilter, $order: [StakingHistoryOrder]) {
		history(filter: $filter, order: $order) {
			asset {
				assetId
			}
			assetAmount {
				value
			}
			fiatAmount {
				value
			}
			type
			createdAt {
				iso8601
			}
			asset {
				assetId
			}
			releaseTimestamp {
				iso8601
				unixTimestamp
			}
			status
			firstRewardPayoutAt {
				iso8601
				unixTimestamp
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetPendingTransactionsGQLService extends Apollo.Query<
	GetPendingTransactionsQuery,
	GetPendingTransactionsQueryVariables
> {
	document = GetPendingTransactionsDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
